/**
 * CR-9072: the Truck Type dropdown — Standard Truck, Mega Truck, or not set.
 *
 * Shared by the haulier's Haulage block and the customer's in-place change,
 * so both offer the same choices.
 *
 * @link CallOffHaulagePanel
 * @link CallOffCustomerHaulageCost
 */
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';
import { TRUCK_TYPE_OPTIONS } from './truckType';

/** Radix Select cannot hold an empty value, so "not set" travels as this. */
const NOT_SET = '__none__';

interface TruckTypeSelectProps {
  id: string;
  /** The stored code, or '' when none is set. */
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export default function TruckTypeSelect({ id, value, onChange, disabled }: TruckTypeSelectProps) {
  return (
    <Select
      value={value || NOT_SET}
      onValueChange={(next) => onChange(next === NOT_SET ? '' : next)}
      disabled={disabled}
    >
      <SelectTrigger id={id}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={NOT_SET}>Not set</SelectItem>
        {TRUCK_TYPE_OPTIONS.map(option => (
          <SelectItem key={option.value} value={option.value}>{option.label}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
